<template>
  <div class="clearfix">
    <!--
      :forceFallback="true"
    -->
    <draggable
      :scroll="true"
      :scrollSensitivity="0"
      :animation="0"
      :class="{
        'card-list-drag-area': true
      }"
      v-model="draggablesList"
      ref="draglist"
      draggable=".draggable-card-item"
      :setData="setDragData"
      :disabled="false"
      :group="group"
      @choose="onChoose"
      @start="onStartDrag"
      @end="onEndDrag"
      :move="onMoveCallback">

      <!--
        :is-editable="listIsEditable"
        :data-element-id="element.$id"
        :data-goal-id="goalId"
        :html-title="element.matched_text"
        :lane-id="listId"
      -->

      <InlineGoalCard
        class="draggable-card-item"
        ref="items"
        v-for="element in draggablesList"
        :key="element.$key"
        :goal="element"
        @focus="unfocusAllTasks( $event )"
        />

      <!--
      <component
        :is="component"
        v-for="goal in my_user_goal_settings"
        :key="goal.$key"
        :goal="goal"
        />
      -->

      <el-card class="inline-goal-card inline-goal-card--dashed" @click.native="onAdd" >
        <div class="text-center pt-6">
          <div><font-awesome-icon size="3x" :icon="['fas', 'plus-circle']"/></div>
          <div>{{addCardText}}</div>
        </div>
      </el-card>

    </draggable>
  </div>
</template>

<script>
import Draggable from 'vuedraggable';
import InlineGoalCard from '@/components/GoalPage/Elements/InlineGoalCard'
import util from '@/util'

// TODO: Support other components

export default {
  props: {
    value: {},
    listId: {},
    listIdParam: { default: null },
    group: { default: 'goals' },
    component: { default: "InlineGoalCard" },
    addCardText: { default: "New Goal" }
  },
  data() {
    return {
      card_dragging: false,
    }
  },
  computed: {
    draggablesList: {
      get() {
        return this.value;
      },
      set(items) {
        /* Check for foreign items */
        const [ foreignItems, regularItems ] = util.partition( items, item => {
          return ( item[ this.listIdParam ] || null ) !== this.listId
        })

        console.log("[" + this.listId + "]", "foreignItems", foreignItems);
        this.$emit('list-move', foreignItems)
        // this.$emit('list-add', foreignItems)

        /* Also check if item was removed from the list */
        /*
        let currentSet = new Set(items.map(item => item.$id));
        let previousArray = this.value.map(item => item.$id);
        let missingItems = previousArray.filter(x => !currentSet.has(x))
        console.log("[" + this.listId + "]", "missingItems", missingItems);
        this.$emit('list-rem', missingItems)
        */

        console.log("[" + this.listId + "]", "regularItems", regularItems);
        if ( regularItems.length !== 0 ) {
          this.$emit('list-reorder', regularItems)
        }
      }
    },
  },
  methods: {
    onAdd() {
      this.$emit('item-add')
    },

    onChoose(evt) {
      this.card_dragging = true;
    },

    onStartDrag(evt) {
      this.card_dragging = true;
      // this.$emit('drag-start', evt);
      this.unfocusAll();
    },

    onEndDrag(evt) {
      this.card_dragging = false;
      // this.$emit('drag-end', evt);
    },

    setDragData(dataTransfer, element) {
      /*
      let payload = {
        taskId: element.dataset.elementId,
        goalId: element.dataset.goalId
      }
      dataTransfer.effectAllowed = 'move';
      dataTransfer.setData("text", JSON.stringify(payload));
      */
    },

    onMoveCallback(evt) {
    },

    unfocusAll( exception ) {
      // not required anymore
    },
  },
  components: {
    Draggable,
    InlineGoalCard,
  }
};
</script>

<style>
.inline-goal-card--dashed > div {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}
.draggable-card-item.sortable-ghost {
  background-color: white !important;
  border: 1px dashed black !important;
}
.draggable-card-item.sortable-ghost > * {
  opacity: 0 !important;
}
.card-list-drag-area {
  min-height: 220px;
  padding: 1px;
}
</style>
